import React from "react";
import { DA_FeatureHandler } from "../../../helpers/FeatureHandler.helper";
import { V1 } from "./v1/BlockProductsV1.component";
import { V2 } from "./v2/BlockProductsV2.component";

const featureName = "blockProducts";
const versions = {
    v1: V1,
    v2: V2,
};

// eslint-disable-next-line unused-imports/no-unused-vars
export const BlockProducts = React.forwardRef(({ version, ...props }: any, ref: any) => (
    <DA_FeatureHandler
        featureName={featureName}
        featureVersions={versions}
        version={version}
        {...props}
    />
));

BlockProducts.displayName = "BlockProducts";
